import { createContext } from 'preact';
import { useContext, useState } from 'preact/hooks';
import { StorageEvent } from '../sdk/storage.event';
import CaasStorageKeys from '../constants/caas.storage.keys';
import { ConsoleEvent } from '../sdk/console.event';

const ConfigContext = createContext({});

function ConfigProvider({ children }) {
  const [config, setConfig] = useState(window.__CAAS__.config);

  const updateStorage = (key, value) => {
    const { storage } = config;
    storage[key] = value;

    const stringifyStorage = JSON.stringify(storage);

    localStorage.setItem(CaasStorageKeys.STORAGE, stringifyStorage);
    StorageEvent.save(stringifyStorage);

    setConfig({ ...config, storage });
  };

  const updateConfigByKey = async (eventData = {}) => {
    return new Promise((resolve, reject) => {
      try {
        const newConfig = { ...config };

        for (const key in eventData) {
          const value = JSON.parse(eventData[key]) || {};
          localStorage.setItem(key, JSON.stringify(value));
          newConfig[key] = value;
          safeConfigKeyUpdate(newConfig, key);
        }
        setConfig(newConfig);
        resolve(newConfig);
      } catch (e) {
        reject(e);
      }
    });
  };

  function safeConfigKeyUpdate(config, key) {
    try {
      window.__CAAS__.config[key] = config[key];
    } catch (e) {
      ConsoleEvent.log(`Error occurred updating config with key ${key}`);
    }
  }

  return (
    <ConfigContext.Provider
      value={{ config, updateStorage, updateConfigByKey }}
    >
      {children}
    </ConfigContext.Provider>
  );
}

export { ConfigContext, ConfigProvider };

export default function useConfig() {
  const { config, updateStorage, updateConfigByKey } =
    useContext(ConfigContext);
  return { config, updateStorage, updateConfigByKey };
}
